import React from 'react';
import { Platform, TextInput, View, StyleSheet, TextStyle } from 'react-native';

import { Color, FontFamily, FontSize } from '@/styles/GlobalStyles';

interface WebDatePickerProps {
    value: string;
    onChange: (value: string) => void;
    style?: any;
    min?: string;
    max?: string;
}

export function WebDatePicker({ value, onChange, style, min, max }: WebDatePickerProps) {
    if (Platform.OS === 'web') {
        return (
            <View style={[styles.container, style]}>
                <input
                    type="date"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    min={min}
                    max={max}
                    style={{
                        border: 'none',
                        background: 'transparent',
                        width: '100%',
                        height: '100%',
                        outline: 'none',
                        fontFamily: FontFamily.regular,
                        fontSize: FontSize.sm,
                        color: Color.gray[300],
                        padding: 0,
                        margin: 0,
                    }}
                />
            </View>
        );
    }

    return (
        <TextInput
            style={[styles.container, styles.nativeInput, style]}
            placeholder="Data (DD/MM/YYYY)"
            value={value}
            onChangeText={onChange}
        />
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: Color.gray.white,
        borderRadius: 8,
        borderWidth: 1,
        borderColor: Color.gray[100],
        paddingHorizontal: 12,
        justifyContent: 'center',
    },
    nativeInput: {
        paddingVertical: 12,
        fontFamily: FontFamily.regular,
        fontSize: FontSize.sm,
    },
});
